module.exports = __webpack_public_path__ + "img/Symbol_7.794ef4dc.png";